<template>
  <!-- record -->
  <div class="receipt" style="font-family: '微软雅黑';">
    <template v-if="westernMedicineChinese !=0">
     <!--a5-->
    <div class="page" v-for="(item, index) in record.medicineDrugPrescriptionList" :id='scriptInfo(index)'
      :key="item.prescription + 'info'">
      <!-- 处方信息 -->
      <div style="font-size: 8pt; line-height: 16pt;font-family: '微软雅黑';">
        <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
        <div style="float: right;">
          <span style="display: inline-block;float: right;">
            <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
          </span>
          <p
            style="width: 24pt;float: right; text-align:center;height: 12pt;line-height: 12pt;border: 1pt solid rgba(51,51,51,1);border-radius: 3pt;display: inline-block;margin-right: 8pt;">
            普通</p>
        </div>
      </div>
      <div style="clear: both;"></div>
      <h3 style="text-align: center; font-size: 16pt;margin-top: 0pt;font-family: '微软雅黑';font-weight: normal;">
        {{ printConfig.titleName || $store.state.global.countInfo.hospitalName }}</h3>
      <h4 style="text-align: center; font-size: 12pt;margin-top: -16pt;font-family: '微软雅黑';font-weight: normal;">成药处方笺&nbsp;({{index + 1}})
      </h4>
      <div class="user-info" style="margin-top: -8pt;font-size: 9pt;font-family: '微软雅黑';">
        <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            姓名：{{ record.patient.patientName }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            年龄：
            <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
            <span v-else>
              <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
                record.patient.month }}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
            </span>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            手机号：{{ record.patient.phoneNo }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            科室：{{ record.inquiryInfo.laboratoryName }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            就诊日期：{{ record.inquiryInfo.clinicalTime }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
          </div>
        </div>
        <div style="clear: both;"></div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div>
            临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div>
            过敏史：{{ record.inquiryInfo.allergyHistory }}
          </div>
        </div>
      </div>
      <!-- 字母 -->
      <div style="line-height: 11pt;">
        <h1 style="font-size: 17pt;display: inline-block;font-family:DFPSongW7;float:left;">R</h1>
        <h2 style="font-size: 12pt;display: inline-block;font-family:DFPSongW7;float:left;margin-left: 4pt;">p</h2>
      </div>
      <div style="clear: both;"></div>
    </div>
    <!-- 处方 -->
    <div class="page" v-for="(item, index) in record.medicineDrugPrescriptionList" :id='idAdd(index)'
      :key="item.prescription">
      <!-- 成药处方 -->
      <TABLE border=0 cellSpacing=0 cellPadding=1 width="100%"
        style="border-collapse:collapse;font-size: 9pt;font-family: '微软雅黑';">
        <TBODY>
          <TR v-for="(it, index) in item.patientDrugList" :key="index + item.prescription">
            <TD height="40pt" style="vertical-align: top;width: 60%;">
              <div>{{ it.drugName }}</div>
              <div style="margin-left:19pt;">
                用法：
                <span style="margin-right: 8pt;" v-if="it.dosage != '' && it.dosage != 0">{{ it.dosage }}
                  {{ it.dosageUnit }}/次</span>
                <span style="margin-right: 8pt;">{{ it.usage }}</span>
                <span style="margin-right: 8pt;">{{ it.frequency }} </span>
              </div>
            </TD>
            <TD style="vertical-align: top;width: 24%;">{{ it.specification }}</TD>
            <TD style="vertical-align: top;width: 26%;">{{ it.totalDosage }}&nbsp;{{ it.totalDosageUnit }}</TD>
          </TR>
        </TBODY>
      </TABLE>
    </div>
    <!-- 诊所信息 -->
    <div style="margin-top: 0px;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-medicine">
      <div
        style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt;width: 100%;font-family: '微软雅黑';">
        <div style="float: left; width: 49.99%;">
          <!-- 医生：<span v-if="printConfig.printDoctorName == 1">{{record.realName}}</span> -->
          医生：<span>{{ record.realName }}</span>
        </div>
        <div style="float: right; width: 49%;text-align: center;">
          <!-- 成药总金额：<span v-if="printConfig.printTotalPrice == 1">￥{{prescriptionAmt}}</span> {{ prescriptionAmt }}-->
          金额：<span v-show="printConfig.printTotalPrice == 1">￥<span id="medicineTotalSum0"></span></span>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="font-size: 9pt;border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;font-family: '微软雅黑';">
        <div style="float: left; width: 24.5%;">
          审查：
        </div>
        <div style="float: left; width: 24.5%;">
          调配：
        </div>
        <div style="float: left; width: 24.5%;">
          核对：
        </div>
        <div style="float: left; width: 24.5%;">
          发药：
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="font-size: 9pt;line-height: 24pt;font-family: '微软雅黑';">
        注：{{ printConfig.remark }}
      </div>
    </div>
    </template>
    <template v-else>
      <!--小票-->
      <div class="page" v-for="(item, index) in record.medicineDrugPrescriptionList" :id='scriptInfo(index)'
           :key="item.prescription + 'info'">
        <!-- 处方信息 -->
        <div style="font-size: 8pt; line-height: 16pt;font-family: '微软雅黑';">
          <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
          <div style="float: right;">
          <span style="display: inline-block;float: right;">
            <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
          </span>
            <p
                style="width: 24pt;float: right; text-align:center;height: 12pt;line-height: 12pt;border: 1pt solid rgba(51,51,51,1);border-radius: 3pt;display: inline-block;margin-right: 20pt;margin-top: 2px">
              普通</p>
          </div>
        </div>
        <div style="clear: both;"></div>
        <h3 style="text-align: center; font-size: 16pt;margin-top: 0pt;font-family: '微软雅黑';font-weight: normal;">
          {{ printConfig.titleName || $store.state.global.countInfo.hospitalName }}</h3>
        <h4 style="text-align: center; font-size: 12pt;margin-top: -16pt;font-family: '微软雅黑';font-weight: normal;">成药处方笺&nbsp;({{index + 1}})
        </h4>
        <div class="user-info" style="margin-top: -8pt;font-size: 9pt;font-family: '微软雅黑';">
          <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
            <div style="display: inline-block;width: 33.333%; float: left;">
              姓名：{{ record.patient.patientName }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              年龄：
              <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
              <span v-else>
              <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
                  record.patient.month }}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
            </span>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
            <div style="display: inline-block;width: 33.333%; float: left;">
              手机号：{{ record.patient.phoneNo }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              科室：{{ record.inquiryInfo.laboratoryName }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              就诊日期：{{ record.inquiryInfo.clinicalTime }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
            </div>
          </div>
        </div>
        <!-- 字母 -->
        <div style="line-height: 11pt;">
          <h1 style="font-size: 17pt;display: inline-block;font-family:DFPSongW7;float:left;">R</h1>
          <h2 style="font-size: 12pt;display: inline-block;font-family:DFPSongW7;float:left;margin-left: 4pt;">p</h2>
        </div>
        <div style="clear: both;"></div>
      </div>
      <!--处方-->
      <div class="page" v-for="(item, index) in record.medicineDrugPrescriptionList" :id='idAdd(index)'
           :key="item.prescription" >
        <!-- 成药处方 -->
        <TABLE border=0 cellSpacing=0 cellPadding=1 width="100%"
               style="border-collapse:collapse;font-size: 9pt;font-family: '微软雅黑';height: 10pt">
          <TBODY>
          <TR v-for="(it, index) in item.patientDrugList" :key="index + item.prescription">
            <TD height="0pt" style="vertical-align: top;width: 60%;">
              <div>{{ it.drugName }}</div>
              <div style="margin-left:19pt;">
                用法：
                <span style="margin-right: 8pt;" v-if="it.dosage != '' && it.dosage != 0">{{ it.dosage }}
                  {{ it.dosageUnit }}/次</span>
                <span style="margin-right: 8pt;">{{ it.usage }}</span>
                <span style="margin-right: 8pt;">{{ it.frequency }} </span>
              </div>
            </TD>
            <TD style="vertical-align: top;width: 24%;">{{ it.specification }}</TD>
            <TD style="vertical-align: top;width: 26%;">{{ it.totalDosage }}&nbsp;{{ it.totalDosageUnit }}</TD>
          </TR>
          </TBODY>
        </TABLE>
      </div>
      <!-- 诊所信息 -->
      <div style="margin-top: 0px;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-medicine">
        <div
            style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt;width: 100%;font-family: '微软雅黑';">
          <div style="float: left; width: 49.99%;">
            <!-- 医生：<span v-if="printConfig.printDoctorName == 1">{{record.realName}}</span> -->
            医生：<span>{{ record.realName }}</span>
          </div>
          <div style="float: right; width: 49%;text-align: center;">
            <!-- 成药总金额：<span v-if="printConfig.printTotalPrice == 1">￥{{prescriptionAmt}}</span> {{ prescriptionAmt }}-->
            金额：<span v-show="printConfig.printTotalPrice == 1">￥<span id="medicineTotalSum0"></span></span>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div style="font-size: 9pt;border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;font-family: '微软雅黑';">
          <div style="float: left; width: 24.5%;">
            审查：
          </div>
          <div style="float: left; width: 24.5%;">
            调配：
          </div>
          <div style="float: left; width: 24.5%;">
            核对：
          </div>
          <div style="float: left; width: 24.5%;">
            发药：
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { BigNumber } from 'bignumber.js';
import {printTemplateA5, printTemplate} from "./print";

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  /** 
   *  type 的几种类型
   *  medicine -> 成药
   *  pieces -> 饮片
   *  infusion -> 输液
   *  apply -> 服帖
   *  infusionCard -> 输液卡
   *  other -> 其他
  */
  props: {
    record: {
      type: Object,
      default: {},
    },
    isReview: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      printTime: '',
      total: "",
      westernMedicineChinese: 1,
    }
  },
  methods: {
    print ({ isReview,index } = {}) {
      this.newPrint()
      // a5纸张打印    且 中药模版和该成药模版类似
      // if(this.westernMedicineChinese !=0) {
      //   console.log("打印成药处方")
      //   this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      //   const {scriptValue} = this.$store.state.global.printConfig;
      //   this.$nextTick(() => {
      //     const LODOP = getLodop();
      //     LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
      //     LODOP.PRINT_INIT('成药处方');
      //     LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '成药处方');
      //     this.record.medicineDrugPrescriptionList.forEach((item, index) => {
      //       // ADD_PRINT_HTM(Top,Left,Width,Height,strHtmlContent)
      //       LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById('medicine-info' + index).innerHTML);
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //       LODOP.ADD_PRINT_HTM('75mm', '5%', '90%', '60mm', document.getElementById('medicine' + index).innerHTML);
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //       document.getElementById('medicineTotalSum0').innerText = this.priceIndex(index)
      //       LODOP.ADD_PRINT_HTM('165mm', '5%', '90%', '36mm', document.getElementById('footer-info-medicine').innerHTML)
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //       LODOP.NewPageA();
      //     })
      //     LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
      //     LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
      //     LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
      //     LODOP.SET_PRINTER_INDEX(scriptValue);
      //     // LODOP.PREVIEW();
      //     // if (isReview) {
      //     LODOP.PREVIEW();
      //     // } else {
      //     //   LODOP.PRINT();
      //     // }
      //   });
      //
      //   // console.log("打印成药处方")
      //   // this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      //   // const {scriptValue} = this.$store.state.global.printConfig;
      //   // this.$nextTick(() => {
      //   //   const LODOP = getLodop();
      //   //   LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
      //   //   LODOP.PRINT_INIT('成药处方');
      //   //   LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '成药处方');
      //   //   this.record.medicineDrugPrescriptionList.forEach((item, index) => {
      //   //     // ADD_PRINT_HTM(Top,Left,Width,Height,strHtmlContent)
      //   //     LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById('medicine-info' + index).innerHTML);
      //   //     LODOP.SET_PRINT_STYLEA(0, "I temType", 1);
      //   //     LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //   //     LODOP.ADD_PRINT_HTM('75mm', '5%', '90%', '110mm', document.getElementById('medicine' + index).innerHTML);
      //   //
      //   //     document.getElementById('medicineTotalSum0').innerText = this.priceIndex(index)
      //   //     LODOP.ADD_PRINT_HTM('155mm', '5%', '90%', '50mm', document.getElementById('footer-info-medicine').innerHTML)
      //   //     // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //   //     // LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
      //   //     LODOP.SET_PRINT_STYLEA(0, "ItemType", 4);
      //   //     LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //   //     LODOP.NewPageA();
      //   //   })
      //   //   LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
      //   //   LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
      //   //   LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
      //   //   LODOP.SET_PRINTER_INDEX(scriptValue);
      //   //   // LODOP.PREVIEW();
      //   //   // if (isReview) {
      //   //   LODOP.PREVIEW();
      //   //   // } else {
      //   //   //   LODOP.PRINT();
      //   //   // }
      //   // });
      // } else {
      //   //小票
      //   this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      //   const { scriptValue } = this.$store.state.global.printConfig;
      //   this.$nextTick(() => {
      //     const LODOP = getLodop();
      //     LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
      //     LODOP.PRINT_INIT('处方打印');
      //     LODOP.SET_PRINT_PAGESIZE(1, '210mm', '140mm', '');
      //     this.record.medicineDrugPrescriptionList.forEach((item, index) => {
      //
      //       LODOP.ADD_PRINT_HTM(0, '5%', '90%', '140mm', document.getElementById('medicine-info' + index).innerHTML);
      //       LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);  //参数1代表固定每页输出上述内容(页眉 页尾)  0是内容
      //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接?
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //
      //       LODOP.ADD_PRINT_HTM('55mm', '5%', '90%', '85mm', document.getElementById('medicine' + index).innerHTML);
      //       LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //
      //       // LODPO.SET_PRINT_MODE("DOUBLE_SIDED_PRINT",true);
      //       // LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
      //       document.getElementById('medicineTotalSum0').innerText = this.priceIndex(index)
      //
      //       LODOP.ADD_PRINT_HTM('105mm', '5%', '90%', '140mm', document.getElementById('footer-info-medicine').innerHTML);
      //       LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 3); //ljj加的跟随链接/
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //       if (index < this.record.patientChineseDrugList.length - 1) {
      //         LODOP.NewPageA();
      //       }
      //     })
      //     LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
      //     LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
      //     LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
      //     LODOP.SET_PRINTER_INDEX(scriptValue);
      //     // LODOP.PREVIEW();
      //     // if (isReview) {
      //     LODOP.PREVIEW();
      //     // } else {
      //     //   LODOP.PRINT();
      //     // }
      //   });
      // }
    },
    newPrint() {
      // console.log(this.record, 'this.record')
      // patientChineseDrugList

      const LODOP = getLodop();
      let title = {
        company: this.printConfig.titleName || this.$store.state.global.countInfo.hospitalName,
        type: '成药处方笺',
        ...this.record.inquiryInfo,
        ...this.record.patient,
        ...this.printConfig,
        realName: this.record.realName,
        sex: this.record.patient.gender == -1 ? '未知' : (this.record.patient.gender == 0 ? '女' : '男'),
      }
      let oldList = JSON.parse(JSON.stringify(this.record.medicineDrugPrescriptionList))
      let chineseNum = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']

      let chunkList = []

      for (let j = 0; j < oldList.length; j++) {
        let printList = oldList[j].patientDrugList
        let obj = {amount: this.priceIndex(j), printTypeTitle: `处方笺(${chineseNum[j]})`}

        let list = printList.reduce((prev, item, index) => {
          // prev.push({printIndex: `组${index + 1}`,  printType: 'group', ...obj})
          prev.push({...item, ...obj})
          prev.push({...item, printType: 'useFn', ...obj})

          if (printList.length == index + 1) {
          } else  {
            prev.push({printType: 'nullRow'})
          }

          return prev
        }, [])

        let splitArrNum = this.westernMedicineChinese != 0 ? 17 : 11

        for (let i = 0; i < list.length; i += splitArrNum) {
          const chunk = list.slice(i, i + splitArrNum);
          chunkList.push(chunk);
        }
      }

      console.log(chunkList, 'medicineChinese:', this.westernMedicineChinese)

      if (this.westernMedicineChinese != 0) {
        for (let i = 0; i < chunkList.length; i++) {
          printTemplateA5(title, chunkList[i], LODOP)
          LODOP.NewPage()
        }
      } else {
        for (let i = 0; i < chunkList.length; i++) {
          printTemplate(title, chunkList[i], LODOP)
          LODOP.NewPage()
        }
      }

      LODOP.PREVIEW()
    },
    async getwesternMedicineChinese () {
      let res = await this.$api.clinicManagement.getHospitalConfig({ configType:18, })
      this.westernMedicineChinese = res.westernMedicineChinese
    },
    // 计算金额
    drugAmt (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取打印配置
    getPrintConfig () {
      this.$api.clinicManagement.getPrintConfit({ configType: 6 }).then((res) => {
        this.printConfig = res;
      })
    },
    scriptInfo (index) {
      return 'medicine-info' + index;
    },
    idAdd (index) {
      return 'medicine' + index
    },
    // 药品单项合计金额-返回0
    drugAmtSub (price, num) {

      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return 0;
      return BN(price).multipliedBy(num).toFixed(2);
    },
    priceIndex(index) {
      if (!this.record.medicineDrugPrescriptionList || this.record.medicineDrugPrescriptionList.length === 0) return 0;
      let sum = 0
      let patientChineseDrug = this.record.medicineDrugPrescriptionList[index]
      let patientChineseDrugPieces = patientChineseDrug.patientDrugList.reduce((c, d) => {
        const salePrice = Number(d.univalence);
        const dosage = Number(d.totalDosage);
        return c + Number(this.drugAmtSub(salePrice, dosage));
      }, 0);
      sum = (patientChineseDrugPieces).toFixed(2)
      console.log('sum',sum)
      return sum
    }
  },
  computed: {
    laboratoryName () {
      return this.$store.state.global.countInfo.laboratoryName;
    },
    prescriptionAmt () {
      if (!this.record.medicineDrugPrescriptionList || this.record.medicineDrugPrescriptionList.length === 0) return '';
      const subMedicineDrugPrescriptionList = this.record.medicineDrugPrescriptionList.reduce((a, b) => {
        const sub = b.patientDrugList.reduce((c, d) => {
          const salePrice = Number(d.univalence);
          const dosage = Number(d.totalDosage);
          return c + Number(this.drugAmtSub(salePrice, dosage));
        }, 0);
        return a + Number(sub);
      }, 0);
      // console.log('====================================');
      // console.log(subMedicineDrugPrescriptionList);
      // console.log('====================================');
      return BN(subMedicineDrugPrescriptionList).toFixed(2);
    },
  },
  mounted () {
    this.getPrintConfig();
    this.getwesternMedicineChinese()
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2px solid #000000;
}

.receipt {
  width: 300px;
  justify-content: space-between;
}

span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1px solid #000000;
  z-index: 100;
  width: 1000px;
  background: white;
  left: -5000px;
  top: 100px;
}
</style>
